export default __webpack_public_path__ + "static/media/ActiveReportVideo.bd1acfc9.svg";